<template>
  <div class="shipping-types-list">
    <vz-switcher
      v-model="currentBlock"
      :items="blockItems"
      public-style
      class="mb-10"
    />
    <public-cargo-grid :items="currentBlockItems" />
    <vz-button
      link
      variant="primary"
      class="text-decoration-underline fs-18 ml-auto"
      @click="showAll = !showAll"
    >
      {{ showAllText }}
    </vz-button>
    <public-get-full-info v-if="isBusiness" />
  </div>
</template>

<script setup lang="ts">
import VzSwitcher from '~/components/ui-kit/vz-switcher.vue';
import {SwitchItem} from '~/types/types';
import VzButton from '~/components/ui-kit/vz-button.vue';
import PublicGetFullInfo from '~/components/public/public-get-full-info.vue';
import PublicCargoGrid from '~/components/public/public-cargo-grid.vue';

const blockItems: SwitchItem[] = [
  {
    value: 'individual',
    title: 'Частным лицам'
  },
  {
    value: 'business',
    title: 'Бизнесу'
  },
]

const currentBlock = ref<'individual'|'business'>('individual')
const showAll = ref(false)

const individualBlocks = [
  {
    title: 'Перевезти вещи',
    imgUrl: '/images/pages/cargo/things.png',
    to: { name: 'shippingtypes-personalitemstransportation' }
  },
  {
    title: 'Перевезти колеса',
    imgUrl: '/images/pages/cargo/wheels.png',
    to: { name: 'shippingtypes-wheels' }
  },
  {
    title: 'Перевезти мотоцикл',
    imgUrl: '/images/pages/cargo/motorcycle.png',
    to: { name: 'shippingtypes-motorcycletransportation' }
  },
  {
    title: 'Перевезти хрупкий груз',
    imgUrl: '/images/pages/cargo/fragile.png',
    to: { name: 'shippingtypes-fragile' }
  },
  {
    title: 'Перевезти мебель',
    imgUrl: '/images/pages/cargo/furniture.png',
    to: { name: 'shippingtypes-furniture' }
  },
  {
    title: 'Перевезти прицеп',
    imgUrl: '/images/pages/cargo/trailer.png',
    to: { name: 'shippingtypes-trailer' }
  },
  {
    title: 'Перевезти автозапчасти',
    imgUrl: '/images/pages/cargo/auto-parts.png',
    to: { name: 'shippingtypes-auto-parts' },
  },
  {
    title: 'Перевезти холодильник',
    imgUrl: '/images/pages/cargo/refrigerator.png',
    to: { name: 'shippingtypes-refrigerator' },
  },
  {
    title: 'Перевезти инструмент',
    imgUrl: '/images/pages/cargo/tools.png',
    to: { name: 'shippingtypes-tools' },
  },
  {
    title: 'Перевезти двигатель',
    imgUrl: '/images/pages/cargo/engine.png',
    to: { name: 'shippingtypes-engine'},
  },
    {
    title: 'Перевезти диван',
    imgUrl: '/images/pages/cargo/sofa.png',
    to: { name: 'shippingtypes-sofa'},
  },
]

const businessBlocks = [
  {
    title: 'Негабаритные грузы',
    imgUrl: '/images/pages/cargo/oversize.png',
    to: { name: 'shippingtypes-oversized' }
  },
  {
    title: 'Доставка между столицами',
    imgUrl: '/images/pages/cargo/capital.png',
    to: { name: 'fast-delivery-capital' },
  },
  {
    title: 'Сборные грузы',
    imgUrl: '/images/pages/cargo/complex.png',
    to: { name: 'delivery-russia' },
  },
  {
    title: 'Доставка в торговые сети',
    imgUrl: '/images/pages/cargo/marketplace.png',
    to: { name: 'networkshops' }
  },
  {
    title: 'Доставка для интернет-магазинов',
    imgUrl: '/images/pages/cargo/networkshop.png',
    to: { name: 'online-store' },
  },
  {
    title: 'Доставка от двери до двери',
    imgUrl: '/images/pages/cargo/pointer.png',
    to: { name: 'address-delivery' },
  },
  {
    title: 'Малогабаритные грузы',
    imgUrl: '/images/pages/cargo/box.png',
    to: { name: 'shippingtypes-smallcargo' },
  },
  {
    title: 'Перевозки по России',
    imgUrl: '/images/pages/cargo/map.png',
    to: { name: 'terminals' },
  },
]

const isBusiness = computed(() => {
  return currentBlock.value === 'business'
})

const currentBlockItems = computed(() => {
  if (showAll.value) {
    return individualBlocks.concat(businessBlocks)
  }
  return currentBlock.value === 'individual' ? individualBlocks : businessBlocks
})

const showAllText = computed(() => {
  return showAll.value ? 'Меньше' : 'Все грузоперевозки'
})
</script>

<style lang="scss" scoped>
.shipping-types-list {
  margin-top: 0;
  background-color: $box-gray;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 25px 30px;

  @media screen and (max-width: $pub-xs) {
    padding: 10px;
  }
}
</style>